import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';

const Utility = () => {
  const utilities = [
    {
      icon: "ShoppingBag",
      title: "DAI KHO Merch",
      desc: "Premium hoodies, tees, and future physical drops. Wear the energy.",
      color: "text-blue-400",
      bg: "bg-blue-500/10",
      borderHover: "group-hover:border-blue-500/50"
    },
    {
      icon: "Activity",
      title: "Reiki Services",
      desc: "Mobile setup incoming. Blending digital assets with physical wellness.",
      color: "text-purple-400",
      bg: "bg-purple-500/10",
      borderHover: "group-hover:border-purple-500/50"
    },
    {
      icon: "Star",
      title: "Holder Benefits",
      desc: "Exclusive access to community events, early drops, and inner circle alpha.",
      color: "text-amber-400",
      bg: "bg-amber-500/10",
      borderHover: "group-hover:border-amber-500/50"
    },
    {
      icon: "Globe",
      title: "Ecosystem Rewards",
      desc: "Integration into the broader DAI KHO brand universe as it expands.",
      color: "text-emerald-400",
      bg: "bg-emerald-500/10",
      borderHover: "group-hover:border-emerald-500/50"
    }
  ];

  return (
    <section className="py-32 px-4 relative">
      <div className="absolute inset-0 bg-gradient-to-b from-transparent via-[#ffffff02] to-transparent pointer-events-none border-y border-white/5" />
      
      <div className="max-w-7xl mx-auto relative z-10">
        <div className="text-center mb-20">
          <motion.h2 
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="text-4xl md:text-5xl font-bold mb-6 text-white"
          >
            Real-World <span className="text-gradient">Utility</span>
          </motion.h2>
          <motion.p 
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: 0.2 }}
            className="text-xl text-slate-400 font-light"
          >
            A token that lives beyond the charts.
          </motion.p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {utilities.map((item, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.1 }}
              className={`glass-panel p-10 rounded-[2rem] transition-all duration-500 group ${item.borderHover} relative overflow-hidden`}
            >
              <div className="absolute bottom-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-current to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" style={{ color: item.color.replace('text-', '') }} />
              
              <div className={`w-16 h-16 rounded-2xl ${item.bg} flex items-center justify-center mb-8 group-hover:scale-110 group-hover:rotate-3 transition-transform duration-300`}>
                <SafeIcon name={item.icon} className={`w-8 h-8 ${item.color}`} />
              </div>
              <h3 className="text-2xl font-bold mb-4 text-white">{item.title}</h3>
              <p className="text-slate-400 text-base leading-relaxed font-light">{item.desc}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Utility;